export const LOGO = {
  crest: "https://customer-assets-lqy194kg.emergentagent.net/job_c13f132e-a6ea-4883-9778-47105b056f5d/artifacts/kyl84cya_SIMO%20final%20logo%20symbol%20%284%29.png",
  wordmarkPurple: "https://customer-assets-lqy194kg.emergentagent.net/job_c13f132e-a6ea-4883-9778-47105b056f5d/artifacts/wc7yll17_Purple%20LOGOS%20SIMO%20UNIVERSITY%20ALL%20%2811%29.png",
  wordmarkWhite: "https://customer-assets-lqy194kg.emergentagent.net/job_c13f132e-a6ea-4883-9778-47105b056f5d/artifacts/kj6mlzwp_LOGOS%20SIMO%20UNIVERSITY%20ALL%20%289%29.png",
};
